package fr.frux.feature.support

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.platform.LocalUriHandler
import androidx.lifecycle.compose.collectAsStateWithLifecycle

/**
 * Composé par `App`, hors du `NavDisplay` : la sollicitation n'est pas un écran et ne doit pas
 * mourir avec l'entrée de navigation courante (ADR 0009, même raisonnement que `MapSurface`).
 *
 * Rien pour une session anonyme (`isAuthenticated = false`) : les endpoints de sollicitation
 * exigent un compte, inutile de créer le ViewModel ni de composer quoi que ce soit.
 */
@Composable
fun SupportPromptHost(
    isMapVisible: Boolean,
    isAuthenticated: Boolean,
) {
    if (!isAuthenticated) return

    val viewModel = rememberSupportPromptViewModel()
    val state by viewModel.state.collectAsStateWithLifecycle()
    val uriHandler = LocalUriHandler.current

    // Uniquement au RETOUR sur la carte (spec : « au retour sur la carte après en être sortie »),
    // pas au démarrage à froid : la carte est la route initiale, donc un simple
    // `LaunchedEffect(isMapVisible)` tirerait dès la première composition. On ne déclenche que sur
    // la transition false → true.
    var wasMapVisible by remember { mutableStateOf(isMapVisible) }
    LaunchedEffect(isMapVisible) {
        if (isMapVisible && !wasMapVisible) viewModel.onMapBecameVisible()
        wasMapVisible = isMapVisible
    }

    if (!isMapVisible) return

    state.prompt?.let { prompt ->
        SupportPromptSheet(
            prompt = prompt,
            onDonate = { url ->
                viewModel.onDonateClicked()
                uriHandler.openUri(url)
            },
            onDismiss = viewModel::onDismiss,
            onOptOut = viewModel::onOptOut,
        )
    }
}
